import React from 'react';
import { InfoIcon } from 'lucide-react';
interface ProfileDetailsProps {
  profile: any;
}
const ProfileDetails: React.FC<ProfileDetailsProps> = ({
  profile
}) => {
  if (!profile.profileDetails) return null;
  const renderProfileTypeDetails = () => {
    const details = profile.profileDetails;
    if (profile.role === 'Forward' || profile.role === 'Midfielder' || profile.role === 'Defender' || profile.role === 'Goalkeeper') {
      // Player profile
      return <div className="space-y-3" data-id="element-407">
          {details.height && details.weight && <div className="flex justify-between" data-id="element-408">
              <div className="flex items-center" data-id="element-409">
                <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-410">
                  <InfoIcon size={16} className="text-green-600" data-id="element-411" />
                </div>
                <div data-id="element-412">
                  <p className="text-sm font-medium" data-id="element-413">Physical</p>
                  <p className="text-xs text-gray-500" data-id="element-414">
                    Height: {details.height} | Weight: {details.weight}
                  </p>
                </div>
              </div>
            </div>}
          {details.dominantSide && <div className="flex justify-between" data-id="element-415">
              <div className="flex items-center" data-id="element-416">
                <div className="w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center mr-3" data-id="element-417">
                  <span className="text-indigo-600 font-bold text-sm" data-id="element-418">
                    {details.dominantSide.charAt(0)}
                  </span>
                </div>
                <div data-id="element-419">
                  <p className="text-sm font-medium" data-id="element-420">
                    Dominant {profile.sport === 'football' ? 'Foot' : 'Hand'}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-421">
                    {details.dominantSide}
                  </p>
                </div>
              </div>
            </div>}
          {details.experience && <div className="flex justify-between" data-id="element-422">
              <div className="flex items-center" data-id="element-423">
                <div className="w-8 h-8 rounded-full bg-orange-100 flex items-center justify-center mr-3" data-id="element-424">
                  <span className="text-orange-600 font-bold text-sm" data-id="element-425">
                    {details.experience}
                  </span>
                </div>
                <div data-id="element-426">
                  <p className="text-sm font-medium" data-id="element-427">Experience</p>
                  <p className="text-xs text-gray-500" data-id="element-428">
                    {details.experience} years as professional
                  </p>
                </div>
              </div>
            </div>}
        </div>;
    }
    // Add other profile types here if needed
    return null;
  };
  return <div className="px-4 py-3 border-b border-gray-100" data-id="element-429">
      <h3 className="text-sm font-medium text-gray-500 uppercase mb-3" data-id="element-430">
        Profile Details
      </h3>
      {renderProfileTypeDetails()}
    </div>;
};
export default ProfileDetails;